import React from 'react';
import { ListColumnType, ListFilterType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import AssetTypeForm from './AssetTypeForm';

// Rename the name of the function:
const AssetTypeList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_asset_type_list',
        defaultParams: { 'deleted': false },
        object: 'asset_type'
    }
    const objectName = 'asset_type.general.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <AssetTypeForm />;
    const onRowClick = 'editModal'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'name', label: 'asset_type.general.name_label' },
    ];

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'asset_type.general.active_asset_types_label',
            params: { 'deleted': false }
        },
        {
            id: 'deleted',
            label: 'asset_type.general.deleted_asset_types_label',
            params: { 'deleted': true }
        }
    ]

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            filters={filters}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            onRowClick={onRowClick}
            isPaginated={isPaginated}
        />
    );
};

export default AssetTypeList;